import styles from "./logo.module.css"
import logo from "../../../../../assets/images/flogo.png"
import { useEffect, useState } from "react"
import { ModalChangeClient } from "../change-client"
export function Logo() {
  const [showModal, setShowModal] = useState(false)

  return (
    <div>
      <img className={styles.logo} src={logo} onClick={() => setShowModal(true)} />
      {showModal && <ModalChangeClient showModal={showModal} hideModal={() => setShowModal(false)}></ModalChangeClient>}
    </div>
  )
}
